import React from 'react';
import { Box, Typography } from "@mui/material";

function NoSearchResults({ 
  title = "No Results Found",
  description = "We couldn't find any data matching your search criteria.",
  message = "Try adjusting your filters or search terms and try again." 
}) {
  return (
    <Box sx={{ textAlign: 'center', p: 3 }}>
      <Typography variant="h6" sx={{ color: '#666', mb: 2 }}>
        🔍 {title}
      </Typography>
      <Typography variant="body1" sx={{ color: '#888', mb: 2 }}>
        {description}
      </Typography>
      <Typography variant="body2" sx={{ color: '#aaa' }}>
        {message}
      </Typography>
    </Box>
  );
}

export default NoSearchResults;
